import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=7ecb6de9"
import script from "./Item.vue?vue&type=script&setup=true&lang=js"
export * from "./Item.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports